<template>
  <div class="photo-gallery-collage">
    <button class="view-all">View All Images</button>
    <picture class="collage-picture--0">
      <img
        width="600"
        height="400"
        :alt="imageOne.title"
        :src="getContentfulImgURL({
        url: imageOne.url,
        width: 900,
        quality: 80,
      })
        ">
      <div class="desktop-image-caption">
        <span>
          {{ imageOne.title }}
        </span>
      </div>
    </picture>
    <picture class="collage-picture--1">
      <img class="lazyload" width="600" height="400" :src="getContentfulImgURL({
        url: imageTwo.url,
        width: 600,
        quality: 10
      })
        " :data-src="getContentfulImgURL({
        url: imageTwo.url,
        width: 600,
        quality: 80
      })
        ">
    </picture>
    <picture class="collage-picture--2">
      <img class="lazyload" width="600" height="400" :src="getContentfulImgURL({
        url: imageThree.url,
        width: 400,
        quality: 10
      })
        " :data-src="getContentfulImgURL({
        url: imageThree.url,
        width: 400,
        quality: 80
      })
        ">
    </picture>
    <picture class="collage-picture--3">
      <img class="lazyload" width="600" height="400" :src="getContentfulImgURL({
        url: imageFour.url,
        width: 400,
        quality: 10
      })
        " :data-src="getContentfulImgURL({
        url: imageFour.url,
        width: 400,
        quality: 80
      })
        ">
    </picture>
  </div>
</template>

<script>
import imageOptimo from "~/mixins/imageOptimoMixin.js"

export default {
  name: 'TourImageDisplayDesktop',
  mixins: [imageOptimo],
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  computed: {
    imageOne() {
      return this.images[0]
    },
    imageTwo() {
      return this.images[1]
    },
    imageThree() {
      return this.images[2]
    },
    imageFour() {
      return this.images[3]
    }
  },
}
</script>

<style lang="scss" scoped>
.photo-gallery-collage {
  height: 100%;
  width: 100%;
  display: grid;
  grid-gap: 8px;
  background-color: rgb(255, 255, 255);
  grid-template-columns: 4fr 1fr 1fr;
  min-height: 400px;
  padding: 0px !important;
  position: relative;
  box-sizing: border-box;

  .collage-picture--0,
  .collage-picture--1,
  .collage-picture--2,
  .collage-picture--3 {
    position: relative;
    cursor: pointer;
    height: 100%;
    position: relative;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
    overflow: hidden;
    transition: box-shadow 0.2s;
    width: 100%;
    box-sizing: border-box;
    img {
      height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      -o-object-position: center;
      object-position: center;
      width: 100%;
    }
  }
  .collage-picture--0 {
    position: relative;
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
    grid-column: 1;
    grid-row: 1/3;
  }

  .collage-picture--1 {
    border-top-right-radius: 2px;
    grid-column: 2/4;
    grid-row: 1;
  }

  .collage-picture--2 {
    grid-column: 2;
    grid-row: 2;
  }

  .collage-picture--3 {
    border-bottom-right-radius: 2px;
    grid-column: 3;
    grid-row: 2;
  }

  .desktop-image-caption {
    position: absolute;
    width: 100%;
    height: 64px;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 14px;
      color: white;
      text-align: center;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .view-all {
    position: absolute;
    z-index: 5;
    top: 32px;
    right: 32px;
    text-transform: uppercase;
    font-weight: 600;
    background-color: white;
    padding: 14px 16px;
    color: #a08f56;

    &:before {
      content: "";

      width: 100%;
      height: 100%;

      top: 0;
      left: 0;
      position: absolute;

      opacity: 0;
      z-index: 30;
      pointer-events: none;
      transition: opacity 0.5s;
      background-color: rgba(255, 255, 255, 0.5);
    }

    &:active:before {
      opacity: 1;
    }
  }
}
</style>

